import { render } from "./OvApplicationView.vue?vue&type=template&id=38ed8627&scoped=true"
import script from "./OvApplicationView.vue?vue&type=script&lang=js"
export * from "./OvApplicationView.vue?vue&type=script&lang=js"

import "./OvApplicationView.vue?vue&type=style&index=0&id=38ed8627&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38ed8627"]])

export default __exports__